import { IANAZone } from "luxon";
import { SharedApiV2 } from "@capstone/mock-api";
import { PaginatedListQuery } from "src/app/core/request-v2-utils";
import { Site } from "src/app/core/sites";
import { ColumnFilter } from "src/app/core/table";
import { Partner } from "src/app/partner/global/partner.model";
import { TicketFilter } from "src/app/partner/help-assist/help-assist.service";
import { serializeColumnFilters } from "src/utils/serialize-v2-filters";

export class HelpAssistListQueryModel extends PaginatedListQuery {
  public constructor(args: ClassProperties<HelpAssistListQueryModel>) {
    super(args);
    this.partnerKey = args.partnerKey;
    this.siteId = args.siteId;
    this.tabFilter = args.tabFilter;
    this.columnFilters = args.columnFilters;
    this.timezone = args.timezone;
  }

  public readonly partnerKey?: Partner["key"] | null;
  public readonly siteId?: Site["id"] | null;
  public readonly tabFilter?: TicketFilter;
  public override readonly columnFilters: readonly ColumnFilter[];
  public override readonly timezone: IANAZone;

  public serialize(): SharedApiV2.GetHelpAssistTicketsQuery {
    return {
      ...this.serializeBase(),
      filter: {
        ...serializeColumnFilters(this.columnFilters, this.timezone),
        filterType: this.tabFilter,
        partnerKey: this.partnerKey?.toString(),
        siteId: this.siteId ?? undefined,
      },
    };
  }
}
